import { Component, OnInit, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment.prod';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sm-employee-subscription',
  templateUrl: './employee-subscription.component.html',
  styleUrls: ['./employee-subscription.component.scss']
})
export class EmployeeSubscriptionComponent implements OnInit {
  imageUrl: string = environment.profileImageBaseUrl;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log(this.data);
  }


}
